module.exports = __webpack_public_path__ + "static/media/wireframes-05a.d423e133.png";